import { useEffect, useState } from "react";
import { ReportServices } from "../../../services/ReportServices";
import { CircularProgress } from "@mui/material";
import Select from "react-select";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import CloseIcon from "../../../assets/crossIcon.svg";
import { useDispatch } from "react-redux";
import { fetchUserAssignedCases } from "../../../redux/caseDetailsSlice";
import { getUser } from "../../../config/user";
const AssignUserToCase = ({
  commandCenterStage,
  commandCenterStageId,
  isOpen,
  AllCases,
  reAssign,
}) => {
  const user = getUser();
  const [userList, setUserList] = useState([]);
  const [userId, setUserId] = useState(reAssign ? null : user?.user?.id);
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();

  const handleSave = async () => {
    setSaving(true);
    if (userId) {
      try {
        // Pass the reAssign flag received as prop (default false if not passed)
        await ReportServices.assignCaseStage(
          commandCenterStageId,
          userId,
          reAssign || false,
        );
        isOpen(null);
        await AllCases();
        dispatch(fetchUserAssignedCases());
      } catch (error) {
        handleApiErrorResponses(error);
        isOpen(null);
        await AllCases();
      }
    } else {
      window.alert("Please select user");
    }
    setSaving(false);
  };

  const getCaseStageUserList = async () => {
    try {
      const response = await ReportServices.getCaseStageUserList(
        commandCenterStage,
        1,
      );
      setUserList(response?.data?.responsibleUsers);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    if (commandCenterStage) {
      getCaseStageUserList();
    }
  }, [commandCenterStage]);

  return (
    <div className="fixed left-0 top-0 w-screen h-screen bg-[#017C5780] flex justify-center items-center z-[1200]">
      {reAssign ? (
        <div className="h-fit w-[40%] bg-white rounded-[16px] py-2">
          <div className="flex justify-end mt-3 mr-4 cursor-pointer">
            <img
              src={CloseIcon}
              alt="close-icon"
              onClick={() => isOpen(null)}
            />
          </div>
          <div className="flex gap-3 px-4 mt-5">
            <div className="font-semibold text-[#191919]">
              Select User To Assign
            </div>
            <div className="w-[60%]">
              <Select
                options={userList}
                getOptionLabel={(options) => {
                  return options["user"]["fullName"];
                }}
                getOptionValue={(options) => {
                  return options["userId"];
                }}
                onChange={(item) => {
                  setUserId(item.userId);
                }}
              />
            </div>
          </div>
          <div className="flex justify-center items-center mt-8">
            {saving ? (
              <CircularProgress />
            ) : (
              <div
                className="text-sm font-semibold text-white bg-[#017C57] uppercase px-12 py-2 rounded-full cursor-pointer"
                onClick={handleSave}
              >
                save
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="h-fit w-[40%] bg-white rounded-[16px] py-2">
          <div className="flex justify-end mt-3 mr-4 cursor-pointer">
            <img
              src={CloseIcon}
              alt="close-icon"
              onClick={() => isOpen(null)}
            />
          </div>

          <div>
            <div className="font-semibold text-[#191919] text-center">
              Are you sure you want to assign this case to yourself.
            </div>
          </div>
          {saving ? (
            <div className="w-full flex justify-center my-3">
              {" "}
              <CircularProgress />
            </div>
          ) : (
            <div className="flex justify-center items-center gap-3 my-3">
              <div
                className="text-sm font-semibold text-white bg-[#017C57] uppercase px-12 py-2 rounded-full cursor-pointer"
                onClick={handleSave}
              >
                Yes
              </div>
              <div
                className="text-sm font-semibold text-white bg-[#017C57] uppercase px-12 py-2 rounded-full cursor-pointer"
                onClick={() => isOpen(null)}
              >
                No
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AssignUserToCase;
